import React, { useEffect, useState } from "react";
import TagAssetsFormList from "./TagAssetsFormList";
import { UserConsumer } from "../../../UserContext";
import TagAssetPopupModal from "./TagAssetPopupModal";

function TagAssets(props) {
	const {
		itemRequisitionId,
		itemCategoryList,
		selectedTagAssetCategory,
		setSelectedTagAssetCategory,
		onTagAssetCategoryChange,
		assetCode,
		showModal,
		setShowModal,
		setIsTagAssetLoaded,
	} = props;

	useEffect(() => {
		setAssetCodeNo(assetCode);
	}, [assetCode]);

	const [serialNo, setSerialNo] = useState(null);
	const [assetCodeNo, setAssetCodeNo] = useState(assetCode);
	const [description, setDescription] = useState(null);
	const [isEditMode, setIsEditMode] = useState(false);
	const [assetTobeEditedId, setAssetTobeEditedId] = useState(null);

	const onEditTagAssets = (data) => {
		setAssetTobeEditedId(data.id);
		setSerialNo(data.serialNo);
		setDescription(data.description);
		setAssetCodeNo(data.assetCode);
		const assetCategory = itemCategoryList?.find((item) => {
			return data.category.toLowerCase() === item.label.toLowerCase();
		});
		setSelectedTagAssetCategory(assetCategory);
		setIsEditMode(true);
		setShowModal(true);
	};
	const clearFormValues = () => {
		setSerialNo("");
		setDescription("");
		setAssetCodeNo("");
		setSelectedTagAssetCategory(null);
	};
	return (
		<UserConsumer>
			{() => {
				return (
					<>
						<TagAssetPopupModal
							showModal={showModal}
							isEditMode={isEditMode}
							onClose={() => {
								setIsEditMode(false);
								setShowModal(false);
								clearFormValues();
							}}
							clearFormValues={clearFormValues}
							assetTobeEditedId={assetTobeEditedId}
							itemRequisitionId={itemRequisitionId}
							itemCategoryList={itemCategoryList}
							selectedTagAssetCategory={selectedTagAssetCategory}
							onTagAssetCategoryChange={(value) =>
								onTagAssetCategoryChange(value)
							}
							assetCode={assetCodeNo}
							serialNo={serialNo}
							onSerialNoChange={(value) => setSerialNo(value)}
							description={description}
							onDescriptionChange={(event) =>
								setDescription(event.target.value)
							}
						/>
						<TagAssetsFormList
							itemRequisitionId={itemRequisitionId}
							editTagAssets={(data) => onEditTagAssets(data)}
							setIsTagAssetLoaded={(value) =>
								setIsTagAssetLoaded(value)
							}
						/>
					</>
				);
			}}
		</UserConsumer>
	);
}

export default TagAssets;
